import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import Mobile from './mobile';
import Web from './web';
import style from './style.css';
import { onChange } from '../../../controller/theme_checkout';
import common from '../../../common/common';

class Redirection extends Component {
  constructor(props) {
    super(props);
  }

  onPreviewToggle = (label, value) => {
    if (this.props && this.props.onPreviewToggle) {
      common.log('onPreviewChange', label);
      this.props.onPreviewToggle(value);
    }
  };

  render({ isMobilePreviewSelected, selected }) {
    return (
      <section>
        <div className={`${style['view-tab']}`}>
          <ul className={`${style['view-list']}`}>
            <li
              className={`${style['view-item']} ${style[!isMobilePreviewSelected ? 'active' : '']}`}
              onClick={this.onPreviewToggle.bind(this, 'Web', false)}
            >
              Web
            </li>
            <li
              className={`${style['view-item']} ${style[isMobilePreviewSelected ? 'active' : '']}`}
              onClick={this.onPreviewToggle.bind(this, 'Mobile', true)}
            >
              Mobile
            </li>
          </ul>
        </div>
        {!isMobilePreviewSelected && selected.web && <Web themeColor={selected.web} />}
        {isMobilePreviewSelected && selected.mobile && <Mobile themeColor={selected.mobile} />}
      </section>
    );
  }
}

export default connect(
  'isMobilePreviewSelected, selected',
  onChange
)(Redirection);



// WEBPACK FOOTER //
// ./checkout/components/redirection/index.js